// extracted by mini-css-extract-plugin
export default {"loaderContainer":"withAuthentication_loaderContainer__MZBHb"};